import { Modal, Col, Image, Row } from "antd";
import React, { useEffect, useState } from "react";
import Header from "../header/header";
import { Container } from "@mui/material";

const industriallist = [
  {
    src: "Sources/images/prouctlist/residential/ongoing/1-4.png",
    title: "ARANYAM",
    content: "...",
    segment: "Residential",
    client: "Aaryan Developers",
    location: "Ahmedabad",
    projectSize: "18,61,200 Sq. ft.",
    projectDes: "3B+GF+21 Floor",
    projectYear: "2023",
    architect: "Apurva Amin",
    consultant: "HNBS Associates",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  
  {
    src: "Sources/images/prouctlist/residential/ongoing/dharohar.avif",
    title: "DHAROHAR",
    content: "...",
    segment: "Residential",
    client: "Sheetal Infrastructure",
    location: "Ahmedabad",
    projectSize: "16,92,500 Sq. ft.",
    projectDes: "3B+GF+22 Floor",
    projectYear: "2024",
    architect: "Hiren Patel & Associates",
    consultant: "Setu Infrastructure",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },

  {
    src: "Sources/images/prouctlist/residential/ongoing/2-2.jpg",
    title: "THE BELLAGIO",
    content: "...",
    segment: "Residential",
    client: "Palak Group",
    location: "Ahmedabad",
    projectSize: "10,60,400 Sq. ft.",
    projectDes: "2B+GF+22 Floor",
    projectYear: "2023",
    architect: "Studio Mansi Shah",
    consultant: "HNBS Associates",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  {
    src: "Sources/images/prouctlist/residential/ongoing/indumati.jpeg",
    title: "INDUMATI PALACE RESIDENCES & PALACE PLAZA",
    content: "...",
    segment: "Residential",
    client: "Baroda crown Holdings Private Limited.",
    location: "Vadodara",
    projectSize: "8,54,000 Sq. ft.",
    projectDes:
      "1B+GF+12 Floor+Terrace (Residential), 1B+GF+3 Floor+Terrace (Commercial)",
    projectYear: "2025",
    architect: "Talib Patel Associates",
    consultant: "Baldridge & Associates Structural Engineering Pvt Ltd.",
    scope:
      "RCC Frame works, Masonary, Plaster works, waterproofing, MEP work, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/residential/ongoing/Amaris.jpg",
    title: "AMARIS",
    content: "...",
    segment: "Residential",
    client: "Adani Realty",
    location: "Ahmedabad",
    projectSize: "8,25,000 Sq. ft.",
    projectDes: "1B+GF+13 Floor",
    projectYear: "2025",
    architect: "Studio Mansi Shah",
    consultant: "P-Cube Consultant LLP",
    scope:
      "Excavation, RCC Frame works, Masonary & Plaster work & waterproofing work.",
  },
  {
    src: "Sources/images/prouctlist/residential/ongoing/Chharanagar.jpg",
    title: "CHHARANAGAR SLUM PROJECT",
    content: "...",
    segment: "Residential",
    client: "Sheetal Infrastructure",
    location: "Ahmedabad",
    projectSize: "7,03,700 Sq. ft.",
    projectDes: "GF+07 Floor",
    projectYear: "2025",
    architect: "VADF Planning & Consultaing",
    consultant: "Maruti Consultant",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  {
    src: "Sources/images/prouctlist/residential/ongoing/quad.jpg",
    title: "THE QUAD",
    content: "...",
    segment: "Residential",
    client: "Sun Builders",
    location: "Ahmedabad",
    projectSize: "6,80,200 Sq. ft.",
    projectDes: "3B+GF+30 Floor",
    projectYear: "2025",
    architect: "HM Architech",
    consultant: "Setu Infrastructure",
    scope:
      "RCC Frame works, masonary, Plaster works, MEP & All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/residential/ongoing/supercity.jpeg",
    title: "SUPERCITY LUXURIA 3",
    content: "...",
    segment: "Residential",
    client: "Shrinivas Organisors Pvt ltd.",
    location: "Ahmedabad",
    projectSize: "4,44,750 Sq. ft.",
    projectDes: "3B+GF+20 Floor",
    projectYear: "2024",
    architect: "9th Street Architech",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  {
    src: "Sources/images/prouctlist/residential/ongoing/Western_photo.jpeg",
    title: "WESTERN OASIS RESIDENTIAL",
    content: "...",
    segment: "RESIDENTIAL",
    client: "True Value Group",
    location: "Ahmedabad",
    projectSize: "4,30,000 Sq. ft.",
    projectDes: "1B+GF+2 floor",
    projectYear: "2024",
    architect: "ADS Architect",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  
  // {
  //   src: "Sources/images/prouctlist/residential/ongoing/Ikaria.png",
  //   title: "IKARIA - EASY LIVING",
  //   content: "...",
  //   segment: "Residential",
  //   client: "Collated Ventures",
  //   location: "Adani Shantigram, Ahmedabad",
  //   projectSize: "2,24,000 Sq. ft.",
  //   projectDes: "1B+GF+13 floor",
  //   projectYear: "2022-Current",
  //   architect: "Studio ARA",
  //   consultant: "N.K. Shah Consulting Engineers LLP",
  //   scope: "RCC Frame works, masonary, Plaster works, waterproofing, All finishing works etc.",
  // },
  // {
  //   src: "Sources/images/prouctlist/residential/ongoing/Gharana.png",
  //   title: "Gharana",
  //   content: "...",
  //   segment: "Residential",
  //   client: "Sheetal Infrastructure",
  //   location: "Ambli, S G Highway, Ahmedabad",
  //   projectSize: "4,93,802 Sq. ft.",
  //   projectDes: "-",
  //   projectYear: "2021-Current",
  //   architect: "ADS Architect P L",
  //   consultant: "Ducon Consultants P L",
  //   scope: "Civil works for R.C.C. Core and shell work Package which shal1 be include Excavation and backfilling, Capping beam and finishing of D wall, RCC works , Block work, Plaster.",
  // },
  // {
  //   // src: "Sources/images/prouctlist/residential/ongoing/1.png",
  //   title: "Secuirty Housing for RIL",
  //   content: "...",
  //   segment: "Residential",
  //   client: "Reliance Industries Ltd.",
  //   location: "Moti Khavdi, Jamnagar",
  //   projectSize: "115,000 Sq. ft.",
  //   projectYear: "2022-Current",
  //   architect: "PVDRS",
  //   consultant: "PVDRS",
  //   scope:
  //     "Civil works for RCC Core and Shell , waterproofing, masonry, all in-building MEP, interior finishing works",
  // },
  // {
  //   src: "Sources/images/prouctlist/residential/ongoing/1.png",
  //   title: "Secuirty Housing for RIL",
  //   content: "...",
  //   segment: "Residential",
  //   client: "Reliance Industries Ltd.",
  //   location: "Moti Khavdi, Jamnagar",
  //   projectSize: "36,338 Sq. ft.",
  //   projectYear: "2021-Current",
  //   architect: "PVDRS",
  //   consultant: "PVDRS",
  //   scope:
  //     "Civil works for RCC Core and Shell , waterproofing, masonry, all in-building MEP, interior finishing works",
  // },
  // {
  //   src: "Sources/images/prouctlist/residential/ongoing/1-2.png",
  //   title: "CELESTE@GODREJ",
  //   content: "...",
  //   segment: "Residential",
  //   client: "Shree Siddhi Group",
  //   location: "Godrej Garden City, Ahmedabad",
  //   projectSize: "1,550,196 Sq. ft.",
  //   projectDes: "14 Floors, 55 Meters",
  //   projectYear: "2022-Current",
  //   architect: "Placekinesis Associates",
  //   consultant: "Japan Shah Consulting Engineers",
  //   scope: "RCC Framework, Masonry ,Plaster.",
  // },
  // {
  //   src: "Sources/images/prouctlist/residential/ongoing/1-3.png",
  //   title: "IKARIA - EASY LIVING",
  //   content: "...",
  //   segment: "Residential",
  //   client: "Alinea Properties LLP",
  //   location: "Adani Shantigram",
  //   projectSize: "2,24,000 Sq. ft.",
  //   projectDes: "13 Floors, 45 Meters",
  //   projectYear: "2022-Current",
  //   architect: "Studio ARA, Ahmedabad",
  //   consultant: "N K Shah Consulting LLP",
  //   scope: "Structural Work, RCC Framework, Finishing Work",
  // },
];
const industrialcompleted = [
    {
    src: "Sources/images/prouctlist/residential/completed/sunatmosphere.png",
    title: "SUN ATMOSPHERE",
     imageGallery: [
      "Sources/images/prouctlist/residential/completed/sunatmosphere.png",
    ],
    content: "Sun Atmosphere are 2 to 3 BHK Appartments And Retail at Shela.",
    segment: "Residential",
    client: "Sun Builders",
    location: "Ahmedabad",
    projectSize: "12,50,000 Sq. ft.",
    projectDes: "2B+GF+14 Floor",
    projectYear: "2024",
    architect: "H M Architech",
    consultant: "Setu Infrastructure",
    scope:
      "RCC Frame works, Masonary, Plaster works, waterproofing,  MEP work, All finishing works etc.",
  },
    {
    src: "/Sources/images/prouctlist/residential/completed/Applewoods/Main Photos/Applewoods-Main.jpg",
    title: "APPLEWOODS",
    imageGallery: [
      "/Sources/images/prouctlist/residential/completed/Applewoods/Main Photos/Applewoods-Main.jpg",
      "/Sources/images/prouctlist/residential/completed/Applewoods/Main Photos/Orchid Greenfield - Applewoods -1.jpg",
      "/Sources/images/prouctlist/residential/completed/Applewoods/Main Photos/Orchid Greenfield - Applewoods -2.jpg",
      "/Sources/images/prouctlist/residential/completed/Applewoods/Main Photos/Orchid Greenfield - Applewoods -3.jpg",
      "/Sources/images/prouctlist/residential/completed/Applewoods/Main Photos/Orchid Greenfield - Applewoods -4.jpg",
      "/Sources/images/prouctlist/residential/completed/Applewoods/Orchid Greenfield-Applewoods -1.jfif",
    ],
    content:
      "The Applewoods township consists of 400 luxurious bungalows accommodated in a plush green environment occupied with open garden spaces, parks and lakes.",
    client: "Goyal Safal Developers",
    location: "Ahmedabad",
    projectSize: "9,00,000 Sq. ft.",
    projectDes: "B+GF+14 Floor",
    projectYear: "2013",
    architect: "Apurva Amin",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
    {
    src: "Sources/images/prouctlist/residential/ongoing/VenusPashmina.png",
    title: "VENUS PASHMINA",
     imageGallery: [
      "Sources/images/prouctlist/residential/ongoing/VenusPashmina.png",
    ],
    content: "...",
    segment: "Residential",
    client: "Venus Lifespace Creators",
    location: "Ahmedabad",
    projectSize: "8,89,160 Sq. ft.",
    projectDes: "2B+GF+22 Floor",
    projectYear: "2024",
    architect: "H M Architech",
    consultant: "Setu Infrastructure",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
    {
    src: "Sources/images/prouctlist/residential/completed/SUN SKY PARK & CENTRAL PLACE/Edits/01-min.jpg",
    title: "SUN SKY PARK",
    imageGallery: [
      "Sources/images/prouctlist/residential/completed/SUN SKY PARK & CENTRAL PLACE/Edits/01-min.jpg",
      // "/Sources/images/NewImages/From Raj Sir/Sun Sky Park/Sun Sky Park.jpg",
      "/Sources/images/prouctlist/residential/completed/SUN SKY PARK & CENTRAL PLACE/Main Photos/Sun Sky Park - 8-min.jpg",
      "/Sources/images/prouctlist/residential/completed/SUN SKY PARK & CENTRAL PLACE/Main Photos/Sun Sky Park - 7-min.jpg",
      "/Sources/images/prouctlist/residential/completed/SUN SKY PARK & CENTRAL PLACE/Edits 2/23-min.jpg",
      "/Sources/images/prouctlist/residential/completed/SUN SKY PARK & CENTRAL PLACE/Edits 2/24-min.jpg",
      "/Sources/images/prouctlist/residential/completed/SUN SKY PARK & CENTRAL PLACE/Edits 2/32-min.jpg",
      "/Sources/images/prouctlist/residential/completed/SUN SKY PARK & CENTRAL PLACE/Edits 2/81-min.jpg",
    ],
    content:
      "Welcome to a new perspective to city living in Ahmedabad through Community, Central Park, Club, Homes, Penthouse etc.",
    client: "Sun Builders",
    location: "Ahmedabad",
    projectSize: "8,41,500 sq. ft.",
    projectDes: "2 Basements Ground Floor+22 Floor",
    projectYear: "2020",
    architect: "Placekinesis Associates",
    consultant: "Setu Infrastructure",
    scope:
      "RCC Frame works, Masonary & Plaster works, waterproofing,  MEP work, All finishing works etc.",
  },
    {
    src: "Sources/images/prouctlist/residential/completed/arvind-aavishkar-img.jpeg",
    title: "ARVIND AAVISHKAR",
    imageGallery: [
      "Sources/images/prouctlist/residential/completed/arvind-aavishkar-img.jpeg",
      "/Sources/images//prouctlist/residential/completed/Arvind Aavishkar/Arvind-5.jpg",
      "/Sources/images/prouctlist/residential/completed/Arvind Aavishkar/Arvind-3.jpg",
      "/Sources/images/prouctlist/residential/completed/Arvind Aavishkar/Arvind-6.jpg",
      "/Sources/images/prouctlist/residential/completed/Arvind Aavishkar/Arvind-1.jpg",
    ],
    content:
      "Arvind Aavishkaar is a residential development constructed by Arvind Smartspaces.",
    client: "Arvind Smartspaces",
    location: "Ahmedabad",
    projectSize: "6,10,000 Sqft.",
    projectDes: "GF+14 Floor ",
    projectYear: "2022",
    architect: "Jagrut And Partners LLP",
    consultant: "Alpha consultancy services",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing,  MEP work, All finishing works etc.",
  },
 {
    src: "Sources/images/prouctlist/residential/ongoing/Oeuvre.png",
    title: "OEUVRE 2",
     imageGallery: [
      "Sources/images/prouctlist/residential/ongoing/Oeuvre.png",
    ],
    content: "...",
    segment: "Residential",
    client: "Madhav Associates",
    location: "Ahmedabad",
    projectSize: "6,06,000 Sq. ft.",
    projectDes: "2B+GF+25 Floor",
    projectYear: "2025",
    architect: "H M Architech",
    consultant: "Setu Infrastructure",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  {
    src: "Sources/images/prouctlist/residential/completed/gharana-img.jpeg",
    title: "GHARANA",
     imageGallery: [
      "Sources/images/prouctlist/residential/completed/gharana-img.jpeg",
      "Sources/images/prouctlist/residential/ongoing/2.png",
    ],
    content: "5 and 6 BHK Sky Villas of 22 floored structure.",
    segment: "Residential",
    client: "Sheetal Infrastructure",
    location: "Ahmedabad",
    projectSize: "5,00,000 Sq.ft.",
    projectDes: "3B+GF+21 Floor",
    projectYear: "2024",
    architect: "ADS Architect",
    consultant: "Ducon Consultants Pvt Ltd.",
    scope: "Excavation, RCC Frame works, Masonary & Plaster work.",
  },
   {
    src: "Sources/images/prouctlist/residential/completed/3.png",
    title: "INDRAPRASTH GULMOHAR",
    imageGallery: [
      "/Sources/images/prouctlist/residential/completed/Indraprastha Gulmohar/Picture2.png",
      "/Sources/images/prouctlist/residential/completed/Indraprastha Gulmohar/Indraprastha Gulmohar - Main.png",
    ],
    content:
      "Indraprasth Gulmohar is a name that will make the difference between elite and everyone else.",
    client: "Deep Group",
    location: "Ahmedabad",
    projectSize: "5,00,000 Sq. ft.",
    projectDes: "2B+GF+14 Floor",
    projectYear: "2019",
    architect: "Hiren Patel Architects",
    consultant: "Setu Infrastructure",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  {
    src: "Sources/images/prouctlist/residential/completed/The Water Fall/The waterfall- Main.jpg",
    title: "THE WATERFALL",
    imageGallery: [
      "/Sources/images/prouctlist/residential/completed/The Water Fall/The waterfall- Main.jpg",
      "/Sources/images/prouctlist/residential/completed/The Water Fall/The waterfall- 1.jpg",
    ],
    content:
      "The waterfall project by Armaan Infrastucture is a high-end luxurious apartment scheme constructed at Ambli Road",
    segment: "Residential",
    client: "Armaan Developer",
    location: "Ahmedabad",
    projectSize: "4,55,000 Sq. ft.",
    projectDes: "4B+GF+11 Floor",
    projectYear: "2022",
    architect: "Scarlett Design",
    consultant: "Ducon Consultant Pvt Ltd",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing,  MEP work, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/residential/completed/One 49/One 49 - Main.jpg",
    title: "ONE49",
    imageGallery: [
      "/Sources/images/prouctlist/residential/completed/One 49/One 49 - Main.jpg",
      "/Sources/images/prouctlist/residential/completed/One 49/One 49 - 1.jpg",
      "/Sources/images/prouctlist/residential/completed/One 49/One 49 - 2.png",
    ],
    content:
      "ONE49, an iconic high-rise residential development is one of the most sought after neighborhoods in Ahmedabad today.",
    client: "Amaya Properties",
    location: "Ahmedabad",
    projectSize: "4,00,000 Sq. ft.",
    projectDes: "2B+GF+19 Floor",
    projectYear: "2018",
    architect: "ONG & ONGS",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope:
      "RCC Frame works, Masonary & Plaster works, waterproofing,  MEP work, All finishing works etc.",
  },
    {
    src: "Sources/images/prouctlist/residential/completed/10.png",
    title: "SHALVIK SHUKAN",
    content:
      "Shalvik Shukan by Aakar Developers offers a total of 132 well-planned and world class residential units with top line specifications.",
    client: "Aakar Developers",
    location: "Gandhinagar",
    projectSize: "3,00,000 Sq. ft.",
    projectDes: "GF+3 Floor",
    projectYear: "2013",
    architect: "Neha Consultants",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  {
    src: "Sources/images/prouctlist/residential/completed/SecurityStaff/Picture1.jpg",
    title: "SECURITY STAFF HOUSING",
    imageGallery: [
      "Sources/images/prouctlist/residential/completed/12.jpeg",
      "Sources/images/prouctlist/residential/completed/SecurityStaff/Picture2.jpg",
    ],
    content:
      "Security Staff Housing Complex project at Jamnagar-LC 01, LC 04 and LC 10",
    segment: "Residential",
    client: "Reliance Industries Ltd.",
    location: "Jamnagar",
    projectSize: "2,81,000 Sq. ft.",
    projectDes: "GF+2 Floor ",
    projectYear: "2023",
    architect: "PVDRS, Ahmedabad",
    consultant: "PVDRS, Ahmedabad",
    scope:
      "RCC Frame works, Masonary, Plaster works, Waterproofing,  MEP work, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/residential/completed/Ikaria/ikaria.jpeg",
    title: "IKARIA - EASY LIVING",
     imageGallery: [
      "Sources/images/prouctlist/residential/completed/Ikaria/ikaria.jpeg",
    ],
    content: "...",
    segment: "Residential",
    client: "Collated Ventures",
    location: "Ahmedabad",
    projectSize: "2,24,000 Sq. ft.",
    projectDes: "1B+GF+13 floor",
    projectYear: "2024",
    architect: "Studio ARA",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope: "RCC Frame works, masonary, Plaster works, waterproofing, All finishing works etc.",
  },
   {
    src: "Sources/images/prouctlist/residential/completed/4.png",
    title: "THE BANYAN",
    imageGallery: [
      "/Sources/images/prouctlist/residential/completed/The Banyan/The Banyan - Main.jpg",
      "/Sources/images/prouctlist/residential/completed/The Banyan/The Banyan - 1.jpg",
      "/Sources/images/prouctlist/residential/completed/The Banyan/The Banyan - 2.jpg",
    ],
    content:
      "For the first time in Gujarat, Quintessentially, the world’s leading luxury lifestyle concierge service is now at ‘The Banyan’.",
    client: "Suryam Group",
    location: "Ahmedabad",
    projectSize: "2,10,000 Sq. ft.",
    projectDes: "1B+GF+12 Floor",
    projectYear: "2018",
    architect: "Design Module",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope:
      "RCC Frame works, Masonary & Plaster works, waterproofing, finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/residential/completed/8.png",
    title: "SLUM REHABILITATION",
    content:
      "A 2,10,000 Sqft project to help nearly 1200 families living in the slums of Amraiwadi with a one-BHK flat with good drainage and supply of drinking water.",
    client: "H N Safal",
    location: "Ahmedabad",
    projectSize: "2,10,000 sq. ft",
    projectDes: "GF+3 Floor",
    projectYear: "2015",
    architect: "Design Module",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope:
      "RCC Frame works, Masonary & Plaster works, waterproofing,  MEP work, All finishing works etc.",
  },
   {
    src: "/Sources/images/prouctlist/residential/completed/SUN EVOQ/IMG_20170527_161857-min.jpg",
    title: "SUN EVOQ",
    imageGallery: [
      "/Sources/images/prouctlist/residential/completed/SUN EVOQ/1518241082__16R1706-min.jpg",
      "/Sources/images/prouctlist/residential/completed/SUN EVOQ/Sun Evoq - 6-min.JPG",
      "/Sources/images/prouctlist/residential/completed/SUN EVOQ/DSC_3950-min.JPG",
      "/Sources/images/prouctlist/residential/completed/SUN EVOQ/DSC_3963-min.JPG",
      "/Sources/images/prouctlist/residential/completed/SUN EVOQ/DSC_3972-min.JPG",
      "/Sources/images/prouctlist/residential/completed/SUN EVOQ/DSC_4086-min.JPG",
    ],
    content:
      "The project offers residential units with top class specifications that meet the expectations of the lifestyle of the urban.",
    client: "Sun Builders",
    location: "Ahmedabad",
    projectSize: "1,25,000 Sq. ft.",
    projectDes: "1B+GF+13 Floor",
    projectYear: "2017",
    architect: "MODO Designs",
    consultant: "Umang Patel",
    scope:
      "RCC Frame works, Masonary & Plaster works, waterproofing,  MEP work, All finishing works etc.",
  },
  {
    src: "Sources/images/prouctlist/residential/ongoing/6.png",
    title: "ALPHABET A",
    imageGallery: [
      "/Sources/images/prouctlist/residential/completed/Alphabet/Picture 3.jfif",
      "/Sources/images/prouctlist/residential/completed/Alphabet/Picture 5.gif",
      "/Sources/images/prouctlist/residential/completed/Alphabet/Picture 6.webp",
    ],
    content: "4 BHK, 5 BHK class-apart lifestyle apartments",
    segment: "Residential",
    client: "Jaydeep Buildcon LLP",
    location: "Ahmedabad",
    projectSize: "1,00,000 Sq. ft.",
    projectDes: "1B+GF+9 Floor",
    projectYear: "2022",
    architect: "9th Street Architects",
    consultant: "Bhoomi Consultants",
    scope: "Excavation, RCC Frame works, Masonary & Plaster work.",
  },
  {
    src: "Sources/images/prouctlist/residential/completed/10.png",
    title: "SHALVIK HOME",
    content:
      "Shalvik Shukan by Aakar Developers offers a total of 132 well-planned and world class residential units with top line specifications.",
    client: "Aakar Developers",
    location: "Gandhinagar",
    projectSize: "1,00,000 Sq. ft.",
    projectDes: "GF+3 Floor",
    projectYear: "2010",
    architect: "Saransh (Manish doshi)",
    consultant: "N.K. Shah Consulting Engineers LLP",
    scope: "RCC Frame works, Masonary & Plaster work.",
  },
  // {
  //   src: "Sources/images/prouctlist/residential/completed/11.png",
  //   title: "SHALVIK HOMES",
  //   imageGallery: [
  //     "/Sources/images/prouctlist/residential/completed/shalvik homes/1.webp",
  //     "/Sources/images/prouctlist/residential/completed/shalvik homes/2.jpg",
  //   ],
  //   content:
  //     "Shalvik Homes by Aakar Developers offers 53 residential bungalows with common plots and play area.",
  //   client: "Aakar Developers",
  //   location: "Vavol, Gandhinagar",
  //   projectSize: "1,00,000 Sq. ft.",
  //   projectDes: "-",
  //   projectYear: "2010",
  //   architect: "Consultants",
  //   consultant: "N.K. Shah Consulting Engineers LLP",
  //   scope: "RCC Framework, Structural Work",
  // },
];

const Residential = () => {
  const [isOngoing, setIsOngoing] = useState(true);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);
  const showModal = (item) => {
    setModalDetails(item);
    setIsModalOpen(true);
    // console.log("open")
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setModalDetails(null);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setModalDetails(null);
  };
  return (
    <>
      <img
        src="Sources/images/prouctlist/residential/1-1-1.JPG"
        alt="404 -Not Given"
        className="about_img"
      />
      <div className="projects-bg">
        {/* <Header /> */}
        <section className="residential py-5">
          <div className="container">
            <p style={{color: '#0d2e61'}} className="is-size-1 has-text-weight-semibold has-text-centered  is-uppercase">
              Residential Projects
            </p>
            <div>
              <Row>
                <Col>
                  <p
                    className="is-size-5 has-text-weight-semibold blue_color mb-2 is-uppercase ongoing-projects"
                    onClick={() => {
                      setIsCompleted(false);
                      setIsOngoing(true);
                    }}
                    style={{
                      borderBottom: isOngoing ? "2px solid #0d2e61" : "none",
                    }}
                  >
                    Ongoing
                  </p>
                </Col>
                <Col>
                  <p
                    className="is-size-5 has-text-weight-semibold blue_color mb-2 is-uppercase completed-projects"
                    onClick={() => {
                      setIsOngoing(false);
                      setIsCompleted(true);
                    }}
                    style={{
                      borderBottom: isCompleted ? "2px solid #0d2e61" : "none",
                    }}
                  >
                    Completed
                  </p>
                </Col>
              </Row>
            </div>
          </div>
        </section>

        <section className="residential pt-0">
          <div className="container">
            <div>
              <Row>
                {isOngoing &&
                  industriallist.map((item, key) => {
                    return (
                      <Col xxl={8} lg={8} md={12} sm={24} xs={24} key={key}>
                        <div
                          className="property_list"
                          style={{ minHeight: "200px" }}
                        >
                          <div className="propertylist_image">
                            <Image
                              src={item.src}
                              alt="404 - Not Given"
                              preview={{
                                getContainer: "#root", // This ensures the image preview is rendered within the root element
                              }}
                            />
                          </div>

                          <div className="propertylist_content p-4">
                            <div className="pt-2">
                              <p style={{wordSpacing: "wrap"}} className="is-size-4 has-text-centered blue_color has-text-weight-semibold project_title_two_line">
                                {item.title}
                              </p>
                            </div>
                            {/* <div className="pt-3">
                          <p className="is-size-6">{item.content}</p>
                        </div> */}
                            {/* <div className="pt-3">
                          <p className="is-size-6">
                            <span className="has-text-weight-semibold">
                              Segment:&nbsp;
                            </span>
                            {item.segment}
                          </p>
                        </div> */}
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Client:&nbsp;
                                </span>
                                {item.client}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Location:&nbsp;
                                </span>
                                {item.location}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6 " >
                                <span className="has-text-weight-semibold" >
                                  Project Size:&nbsp;
                                </span>
                                {item.projectSize}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Project Description:&nbsp;
                                </span>
                                {item.projectDes}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Project Year:&nbsp;
                                </span>
                                {item.projectYear}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Architect:&nbsp;
                                </span>
                                {item.architect}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Str. Consultant:&nbsp;
                                </span>
                                {item.consultant}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Scope:&nbsp;
                                </span>
                                {item.scope}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
              </Row>
            </div>
            <div>
              <Row>
                {isCompleted &&
                  industrialcompleted.map((item, key) => {
                    return (
                      <Col xxl={8} lg={8} md={12} sm={24} xs={24} key={key}>
                        <div
                          className="property_list"
                          style={{ minHeight: "200px" }}
                        >
                          <div className="propertylist_image">
                            <img
                              src={item.src}
                              alt="404 - Not Given"
                              onClick={() => showModal(item)}
                            />
                          </div>

                          <div className="propertylist_content p-4">
                            <div className="pt-2">
                              <p className="is-size-4 has-text-centered blue_color has-text-weight-semibold text-uppercase project_title_two_line">
                                {item.title}
                              </p>
                            </div>
                            {/* <div className="pt-3">
                            <p className="is-size-6">{item.content}</p>
                          </div>
                          <div className="pt-3">
                            <p className="is-size-6">
                              <span className="has-text-weight-semibold">
                                Segment:&nbsp;
                              </span>
                              Residential
                            </p>
                          </div> */}
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Client:&nbsp;
                                </span>
                                {item.client}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Location:&nbsp;
                                </span>
                                {item.location}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold" >
                                  Project Size:&nbsp;
                                </span>
                                {item.projectSize}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6" >
                                <span className="has-text-weight-semibold">
                                  Project Description:&nbsp;
                                </span>
                                {item.projectDes}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Completed Year:&nbsp;
                                </span>
                                {item.projectYear}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Architect:&nbsp;
                                </span>
                                {item.architect}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Str. Consultant:&nbsp;
                                </span>
                                {item.consultant}
                              </p>
                            </div>
                            <div className="pt-3">
                              <p className="is-size-6">
                                <span className="has-text-weight-semibold">
                                  Scope:&nbsp;
                                </span>
                                {item.scope}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
              </Row>
              <div>
                {modalDetails && (
                  <Modal
                    getContainer="#root"
                    title={modalDetails.title}
                    open={isModalOpen}
                    footer={null}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    mask={true}
                    style={{ boxShadow: "none" }}
                    width={1000}
                    className="CompletedModal"
                  >
                    <Row>
                      {/* Check if imageGallery exists and has images */}
                      {modalDetails.imageGallery &&
                      modalDetails.imageGallery.length > 0 ? (
                        modalDetails.imageGallery.map((imgSrc, idx) => (
                          <Col lg={8} md={12}>
                            <div className="image_position">
                              <Image
                                key={idx}
                                src={imgSrc}
                                alt={`Gallery Image ${idx + 1}`}
                                style={{ cursor: "pointer" }}
                                preview={{
                                  getContainer: "#root",
                                }}
                              />
                            </div>
                          </Col>
                        ))
                      ) : (
                        <Col
                          lg={24}
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          <p>No Images Found</p>
                        </Col>
                        /* Show this if imageGallery is empty */
                      )}
                    </Row>
                  </Modal>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Residential;
